import styled, { css } from 'styled-components';
import Select from 'react-select';
import {
  gray,
  spacer,
  themeColor,
  multiply,
  color,
  getThemeProp,
  fontSize,
  zIndex,
  borderRadius,
  mediaBreakpointUp,
  getLeftValue,
  fontStyle,
} from '@whitelabel/helpers/style';
import { ReactComponent as IconLoading } from '@whitelabel/media/icons/loading.svg';

export const StyledSelect = styled(Select)<{ $rtl: boolean }>`
  .react-select__control {
    height: ${multiply(spacer, 2.6875)};
    font-size: ${multiply(fontSize('base'), 1.125)};
    border-color: ${gray(500)};
    border-radius: ${borderRadius('base')};
    cursor: pointer;

    ${mediaBreakpointUp('lg')`
      font-size: ${fontSize('lg')};
      height: ${multiply(spacer, 2.875)};
    `}
  }

  .react-select__control--is-disabled {
    background-color: ${gray(200)};
    border-color: ${gray(400)};
  }

  .react-select__single-value--is-disabled {
    color: ${gray(600)};
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    padding-inline-end: ${spacer};

    svg {
      color: ${gray(600)};
    }
  }

  .react-select__value-container {
    padding-inline-start: ${multiply(spacer, 0.75)};

    ${mediaBreakpointUp('md')`
      padding-inline-start: ${spacer};
    `}
  }

  .react-select__control--is-focused,
  .react-select__control--menu-is-opened {
    border-color: ${gray(500)};
    box-shadow: none;
  }

  .react-select__control,
  .react-select__control--is-focused,
  .react-select__control--menu-is-opened {
    ${({ invalid }) =>
      invalid &&
      css`
        border-color: ${themeColor('danger')};
      `}

    &:hover {
      border-color: ${gray(700)};

      ${({ invalid }) =>
        invalid &&
        css`
          border-color: ${themeColor('danger')};
        `}
    }
  }

  .react-select__menu {
    ${fontStyle('formValue')}
    z-index: ${zIndex('contentLayer')};
    margin-top: ${multiply(spacer, 0.75)};

    &:before {
      ${getLeftValue('0.8125rem')}
      position: absolute;
      top: -${multiply(spacer, 1.25)};
      z-index: 6;
      width: 0;
      height: 0;
      border-inline-end: ${multiply(spacer, 0.75)} solid transparent;
      border-bottom: ${multiply(spacer, 1.25)} solid white;
      border-inline-start: ${multiply(spacer, 0.75)} solid transparent;
      content: '';
    }
    &:after {
      ${getLeftValue('0.75rem')}
      position: absolute;
      top: -${multiply(spacer, 1.3125)};
      z-index: 5;
      width: 0;
      height: 0;
      border-inline-end: ${multiply(spacer, 0.8125)} solid transparent;
      border-bottom: ${multiply(spacer, 1.3125)} solid ${gray(400)};
      border-inline-start: ${multiply(spacer, 0.8125)} solid transparent;
      content: '';
    }

    .react-select__option--is-focused {
      background-color: ${gray(200)};
    }

    .react-select__option--is-selected {
      color: ${gray(700)};
      background-color: ${themeColor('primary')};
    }
  }

  /* stylelint-disable-next-line order/order */
  ${({ isMulti }) =>
    isMulti &&
    css`
      .react-select__control {
        flex-direction: row-reverse;
        height: auto;
        min-height: ${multiply(spacer, 4)};
        padding: ${multiply(spacer, 0.75)} 0;

        .react-select__clear-indicator {
          display: none;
        }

        .react-select__indicators {
          margin: 0 ${spacer} 0 ${multiply(spacer, 1.5)};
        }
      }

      .react-select__value-container {
        padding-top: 0;
        padding-bottom: 0;
        padding-inline-start: 0;
      }

      .react-select__multi-value {
        background: ${color('white')};
        border-radius: ${multiply(spacer, 1.5)};
        border: ${getThemeProp('borderWidth')} solid ${gray(500)};
        align-content: center;

        .react-select__multi-value__label {
          font-size: ${multiply(fontSize('base'), 1.25)};
          padding: ${multiply(spacer, 0.0625)} 0 ${multiply(spacer, 0.0625)} ${spacer};
        }

        .react-select__multi-value__remove {
          border-radius: 0 ${spacer} ${spacer} 0;
          padding-inline-start: ${multiply(spacer, 0.3125)};
          padding-inline-end: ${multiply(spacer, 0.3125)};

          svg {
            color: ${gray(600)};
            padding: ${multiply(spacer, 0.25)};
            width: ${multiply(spacer, 1.625)};
            height: ${multiply(spacer, 1.625)};
            border-radius: ${spacer};
            transition: color 0.2s ease-out, background-color 0.2s ease-out;
          }

          &:hover {
            background: none;
            color: inherit;

            svg {
              color: ${gray(700)};
              background-color: ${gray(300)};
            }
          }
        }
      }
    `}
`;

export const StyledSelectLoadingIcon = styled(IconLoading)`
  position: absolute;
  top: ${multiply(spacer, 1.34375)};
  left: ${spacer};
  display: block;
  width: ${multiply(spacer, 1.25)};
  height: ${multiply(spacer, 1.0625)};
  color: ${gray(600)};
`;
